module.exports = __webpack_public_path__ + "static/media/nubank.59ce481c.png";